import React from 'react';
import dayjs from 'dayjs';
import {FormattedMessage} from 'react-intl';
import {InvoiceMatch} from '../../types';
import PopupCreateReceipt from '../PopupCreateReceipt';
import styles from './styles.module.scss';

interface MatchedInvoiceProps {
  invoice: InvoiceMatch,
  tableRowID: number
}

const MatchedInvoice = ({
                          invoice,
                          tableRowID
                        }: MatchedInvoiceProps) => {
  return (
    <div className={styles.itemView}>
      <div className={styles.bodyCell}>
        <div className={'font-weight-bold'}>{invoice._id}</div>
      </div>
      <div className={styles.bodyCell}>
        <div className={'font-weight-bold'}>{invoice.agentId}</div>
        <div>{invoice.agentName}</div>
      </div>
      <div className={styles.bodyCell}>
        <div className={'font-weight-bold'}>{invoice.customerID}</div>
        <div>{invoice.customerName}</div>
      </div>
      <div className={styles.bodyCell}>
        <div className={'font-weight-bold'}>{dayjs(invoice.datetime).format('DD-MM-YYYY')}</div>
      </div>
      <div className={styles.bodyCell}>
        <div className={'font-weight-bold'}>{invoice.total?.withVat}</div>
        <div className={'font-weight-bold'}>
          {invoice.total.vat === 0
            ? (
              <div className={'text-danger'}>
                <FormattedMessage
                  id="bankStatements-matchedInvoices-popup-column-amount-vatExcluded"
                  defaultMessage="Excluding VAT"
                />
              </div>
            )
            : (
              <div className={'text-success'}>
                <FormattedMessage
                  id="bankStatements-matchedInvoices-popup-column-amount-vatIncluded"
                  defaultMessage="Including VAT"
                />
              </div>
            )}
        </div>
      </div>
      <div className={styles.bodyCell}>
        <div>{invoice.statusName}</div>
      </div>
      <div className={styles.bodyCell}>
        <div>{invoice.comments}</div>
      </div>
      <div className={styles.bodyCell}>
        <PopupCreateReceipt
          _id={invoice._id}
          agentId={invoice.agentId}
          amount={invoice.total.withVat}
          customerEmail={invoice.customerEmail || ''}
          customerID={invoice.customerID || ''}
          customerName={invoice.customerName}
          status={invoice.status}
          tableRowID={tableRowID}
        />
      </div>
    </div>
  );
};


export default MatchedInvoice;
